//import * as amplify from "../util/amplify.ts";
//amplify.subscribe('pageUnload',()=>{INITIALIZED = undefined})

async function loadScript(src :string){
  return new Promise((resolve,reject)=>{
    var script = document.createElement("script");
    script.onload = resolve
    script.onerror = reject
    script.async = true;
    script.src = src;
    document.getElementsByTagName("head")[0].appendChild(script);
  })
}
const DATAS : {[key :string]:{dim:[number,number],id:string,SLOT?:any}} = {
  homepage_mediumrectangle: {dim:[300, 250], id:'div-gpt-ad-1742226324243-0'},
  homepage_leaderboard:     {dim:[728, 90], id:'div-gpt-ad-1742226648734-0'},
  calendar_mediumrectangle: {dim:[300, 250], id:'div-gpt-ad-1742226760311-0'},
  othersections_mediumrectangle:{dim:[300, 250], id:'div-gpt-ad-1742235788007-0'},
  othersections_portait:    {dim:[300, 600], id:'div-gpt-ad-1742235740022-0'},
  mobile_leaderboard:       {dim:[320, 50], id:'div-gpt-ad-1742235662912-0'},
  interstitial:             {dim:[1, 1], id:'div-gpt-ad-1742235592216-0'}
}

var INITIALIZED :Promise<{cmd:{push:(command:Function)=>void}}>;
function initialized(){
  if(INITIALIZED!==undefined) return INITIALIZED
  return INITIALIZED = loadScript("https://securepubads.g.doubleclick.net/tag/js/gpt.js").then(()=>{
    var googletag = window.googletag = window.googletag || { cmd: [] };
  
    googletag.cmd.push(() => {
      googletag.pubads().disableInitialLoad();
      googletag.pubads().enableSingleRequest();
      googletag.enableServices();
      // Enable SRA and services.
      
    })
    return googletag;
  
  })
  
}


export async function addSlot(type :string){
  var gtag = await initialized();
  var slotConfig = DATAS[type];
  gtag.cmd.push(() => {
    if(slotConfig.SLOT === undefined){
      slotConfig.SLOT = googletag.defineSlot("/22780788599/familywall.com/"+type, slotConfig.dim, slotConfig.id)
      if (slotConfig.SLOT) {
        slotConfig.SLOT.addService(googletag.pubads());
      }
    }
    googletag.pubads().refresh([slotConfig.SLOT]);
  })
  
} 
export async function destroySlot(type :string){

  //commented because worse than without

  var gtag = await initialized();
  var slotConfig = DATAS[type];
  gtag.cmd.push(() => {
    googletag.destroySlots([slotConfig.SLOT])
    slotConfig.SLOT = undefined;
  })
  
} 

export function getDatas(type :string){
  return DATAS[type]
  
}